const getStockExchangesNames = (stockExchanges = []) =>
  stockExchanges.map((s) => s.name);

export default getStockExchangesNames;
